import React, { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  compactView?: boolean;
  children: React.ReactNode;
  className?: string;
}

interface CardType extends React.FC<CardProps> {
  Image: React.FC<HTMLAttributes<HTMLDivElement>>;
  Body: React.FC<HTMLAttributes<HTMLDivElement>>;
  Link: React.FC<HTMLAttributes<HTMLDivElement>>;
}

const Image: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => {
  const classes = `card__image ${className || ""}`;
  return (
    <figure className={classes} {...rest}>
      {children}
    </figure>
  );
};

const Body: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => {
  const classes = `card__body ${className || ""}`;
  return (
    <address className={classes} {...rest}>
      {children}
    </address>
  );
};

const Link: React.FC<HTMLAttributes<HTMLDivElement>> = ({
  className,
  children,
  ...rest
}) => {
  const classes = `card__link ${className || ""}`;
  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
};

const Card: CardType = ({
  compactView = false,
  className,
  children,
  ...rest
}) => {
  const classes = `card ${compactView && "card--compact"} ${className || ""}`;
  return (
    <article className={classes} {...rest}>
      {children}
    </article>
  );
};

Card.Image = Image;
Card.Body = Body;
Card.Link = Link;

export default Card;
